import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEnvelope = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M20 4H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2Zm0 2v.511l-8 6.223-8-6.222V6h16ZM4 18V9.044l7.386 5.745a.994.994 0 0 0 1.228 0L20 9.044 20.002 18H4Z"
	})
});
export default SvgEnvelope;
